// src/components/ChatConversation.jsx
import React, { useEffect, useRef, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMessagesDonneurOrdre, sendMessageDonneurOrdre } from "../../redux/actions/matchActions";
import { useWS } from "../UseWebSocket";

const ChatConversationDonneurOrdre = ({ toUserId, onBack, onMessageSent }) => {
  const [newMessage, setNewMessage] = useState("");
  const { token, user } = useSelector((state) => state.auth || {});
  const { selectedMatchDonneurOrdre } = useSelector((state) => state.match);
  const typingUsers = useSelector((state) => state.typing.typingUsers);

  const match = selectedMatchDonneurOrdre;
  const messages = selectedMatchDonneurOrdre?.messages || [];
  const dispatch = useDispatch();

  const messagesEndRef = useRef(null);
  const { sendTypingStatus } = useWS();

  // Scroll automatique jusqu'au dernier message
  const scrollToBottom = useCallback(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
    }
  }, []);

  useEffect(() => {
    scrollToBottom();
  }, [messages, scrollToBottom]);


  // Typing avec debounce
  const typingTimeoutRef = useRef(null);
  const handleTyping = () => {
    if (!sendTypingStatus || !match) return;

    sendTypingStatus(match.id, toUserId, true);

    // Reset du timer
    if (typingTimeoutRef.current) clearTimeout(typingTimeoutRef.current);
    typingTimeoutRef.current = setTimeout(() => {
      sendTypingStatus(match.id, toUserId, false);
    }, 1500); // 1.5s après le dernier caractère
  };

  const handleSend = () => {
    if (!newMessage.trim()) return;

    dispatch(sendMessageDonneurOrdre(token, match.id, newMessage, toUserId))
      .then(() => dispatch(fetchMessagesDonneurOrdre(token, match.id)));

    if (sendTypingStatus) sendTypingStatus(match.id, toUserId, false);

    setNewMessage("");
    if (onMessageSent) onMessageSent();
  };

  const handleChange = (e) => {
    setNewMessage(e.target.value);
    handleTyping();
  };

  const formatMessageTime = (createdAt) => {
    const date = new Date(createdAt + "Z");
    return date.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit" });
  };

// 👇 Fonction pour grouper les messages par jour
  const groupMessagesByDate = (messages) => {
    const groups = {};
    messages.forEach((msg) => {
      const date = new Date(msg.createdAt + "Z");
      const now = new Date();
      const yesterday = new Date();
      yesterday.setDate(now.getDate() - 1);

      let key = "";
      if (
        date.getDate() === now.getDate() &&
        date.getMonth() === now.getMonth() &&
        date.getFullYear() === now.getFullYear()
      ) {
        key = "Aujourd’hui";
      } else if (
        date.getDate() === yesterday.getDate() &&
        date.getMonth() === yesterday.getMonth() &&
        date.getFullYear() === yesterday.getFullYear()
      ) {
        key = "Hier";
      } else {
        key = date.toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
      }

      if (!groups[key]) groups[key] = [];
      groups[key].push(msg);
    });

    return groups;
  };


  const groupedMessages = groupMessagesByDate(messages);
  const isTyping = typingUsers?.[match?.id]?.[toUserId] || false;

  return (
    <div className="chat-conversation">
      <div
        className="chat-messages"
        style={{ overflowY: "auto", maxHeight: "400px", padding: "10px" }}
      >
        {Object.entries(groupedMessages).map(([dayLabel, msgs]) => (
          <div key={dayLabel}>
            <div
              className="day-label"
              style={{ textAlign: "center", margin: "10px 0", color: "#888", fontWeight: "bold" }}
            >
              {dayLabel}
            </div>
            {msgs.map((m, index) => (
              <div
                key={index}
                className={`chat-message ${m.fromUserId === user.idUser ? "sent" : "received"}`}
                style={{ marginBottom: "8px" }}
              >
                <h3 style={{ margin: "0 0 4px 0", fontSize: "0.85rem" }}>
                  {m.fromUserId === user.idUser
                    ? "Moi"
                    : match.prestataire?.firstNamePrestataire || match.donneurOrdre?.prenomDonneurOrdre + " de " + match.donneurOrdre?.raisonSocialeDonneurOrdre}
                </h3>
                <p style={{ margin: "0" }}>{m.content}</p>
                <span className="time" style={{ fontSize: "0.75rem", color: "#999" }}>
                  {formatMessageTime(m.createdAt)}
                </span>
              </div>
            ))}
          </div>
        ))}
        <div ref={messagesEndRef} />

      </div>
      {isTyping && (
        <div style={{ fontStyle: "italic", color: "#555", margin: "5px 0" }}>
          En train de taper...
        </div>
      )}
      <div className="chat-input" style={{ display: "flex", marginTop: "10px" }}>
        <input
          type="text"
          placeholder="Écris un message..."
          value={newMessage}
          onChange={handleChange}
          onKeyDown={(e) => e.key === "Enter" && handleSend()}
          style={{ flex: 1, padding: "8px", borderRadius: "4px", border: "1px solid #ccc" }}
        />
        <button
          onClick={handleSend}
          style={{
            marginLeft: "8px",
            padding: "8px 12px",
            borderRadius: "4px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
          }}
        >
          Envoyer
        </button>
      </div>
    </div>
  );
};

export default ChatConversationDonneurOrdre;
